import {createApi} from '@reduxjs/toolkit/query/react';
import {customAxiosBaseQuery} from '../API/customAxiosBaseQuery';
import {BaseResponseType} from '../types/TypesStore';

import {dynamicAPI} from '../API/api';
import {
	HistoryMarketType,
	ResponseAchieveRecommend,
	StatLiders,
	StatNewbie,
	StatsElement,
} from '../types/MyDynamicsData';
import {Stat} from '../Components/Charts/QualificationChartTeamValue';
import {Qualification} from '../Components/Charts/QualificationHistoryChart';

export const myDynamicApi = createApi({
	reducerPath: 'myDynamicApi',
	baseQuery: customAxiosBaseQuery,
	tagTypes: [
		'command-volume-day',
		'command-volume-month',
		'achieveRecommend',
		'month-newbie',
		'liders',
	],

	endpoints: (builder) => ({
		getCommandVolume: builder.query<
			BaseResponseType & {stats: StatsElement[]},
			string
		>({
			query: (month) => ({
				func: dynamicAPI.getStatDayVolumeCommand,
				args: [month],
			}),
			providesTags: ['command-volume-day'],
		}),
		getAchieveRecommend: builder.query<
			BaseResponseType & ResponseAchieveRecommend,
			void
		>({
			query: () => ({
				func: dynamicAPI.getAchieveRecommend,
				args: [],
			}),
			providesTags: ['achieveRecommend'],
		}),
		getHistoryQlfc: builder.query<
			BaseResponseType & {qlfc: Qualification[]},
			void
		>({
			query: () => ({
				func: dynamicAPI.getHistoryQlfc,
				args: [],
			}),
			providesTags: ['achieveRecommend'],
		}),
		getHistoryMarketplan: builder.query<
			BaseResponseType & {mp: HistoryMarketType[]},
			void
		>({
			query: () => ({
				func: dynamicAPI.getHistoryMarketplan,
				args: [],
			}),
			providesTags: ['achieveRecommend'],
		}),
		statMonthVolumeCommand: builder.query<
			BaseResponseType & {stats: Stat[]},
			string
		>({
			query: (month) => ({
				func: dynamicAPI.getStatMonthVolumeCommand,
				args: [month],
			}),
			providesTags: ['command-volume-month'],
		}),
		getMonthNewbie: builder.query<
			BaseResponseType & {stats: StatNewbie[]},
			string
		>({
			query: (month) => ({
				func: dynamicAPI.getMonthNewbie,
				args: [month],
			}),
			providesTags: ['month-newbie'],
		}),
		getStatLiders: builder.query<
			BaseResponseType & {stats: StatLiders[]},
			{month: string; type_sort: string}
		>({
			query: (data) => ({
				func: dynamicAPI.getStatLiders,
				args: [data],
			}),
			providesTags: ['liders'],
		}),
	}),
});

export const {
	useGetCommandVolumeQuery,
	useGetAchieveRecommendQuery,
	useStatMonthVolumeCommandQuery,
	useGetMonthNewbieQuery,
	useGetStatLidersQuery,
	useGetHistoryQlfcQuery,
	useGetHistoryMarketplanQuery,
} = myDynamicApi;
